import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app/store";

interface blogsState {
  data: {} | any | null;
  totalPages: number | null;
}

const initialState: blogsState = {
  data: null,
  totalPages: null,
};

export const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    setblogs: (state, action) => {
      state.data = action.payload;
      state.totalPages = action.payload.totalPages;
    },
    resetblogs: (state) => {
      state = initialState;
    },
  },
});

export const { setblogs, resetblogs } = blogsSlice.actions;

export const getBlogsData = (state: RootState) => state.blogs.data;
export const getBlogTotalPages = (state: RootState) => state.blogs.totalPages;

export default blogsSlice.reducer;
